import actions from './navigate.actions';
import mutations from './navigate.mutations';

export default {
  actions,
  mutations,
  state: null
};

